import styled from 'styled-components';

export const StyledCrmExportBulkContainer = styled.div`
  position: relative;
`;
